import Cart from '../cart/cart';
import { getMinicartDisplayConfigs, setMinicartBodyScrollToEnd, handlePostCartAdd, miniCartReportingUrl } from '../product/base';

let updateMiniCart = true;

export default class MiniCart {
    init() {
        const cart = new Cart();
        cart.init();

        $('.minicart').on('count:update', (event, count) => {
            if (count && $.isNumeric(count.quantityTotal)) {
                $('.minicart .minicart-quantity')
                  .removeClass('d-none')
                  .text(count.quantityTotal);
                $('.icon-cart-full').removeClass('d-none');
                $('.icon-cart-empty').addClass('d-none');
                $('.minicart .minicart-subtotal').attr('value', count.cart.totals.subTotal.formatted);
                $('.minicart .minicart-link').attr({
                    'aria-label': count.minicartCountOfItems
                });
            }
        });
        $(window).on('idt:add-to-cart', function (event) {
            const data = event.detail;
            if (!data.source || (data.source !== 'widget-isy-ai' && data.source !== 'chat-ai')) {
                console.log('Origine non accettata per addToCart: ', data.source);
                return;
            }

            const addProductUrl = $('.ai-assistant-container').data('add-to-cart-url');
            const body = new URLSearchParams();
            body.append('pid', data.id);
            body.append('quantity', data.quantity.toString());

            $.spinner().start();

            fetch(addProductUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: body.toString()
            })
            .then((res) => res.json())
            .then((data) => {
                handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();
                miniCartReportingUrl(data.reportingURL);
                $('body').trigger('addToCart:rapidMessage', data);
            })
            .catch((err) => {
                const e = err;
                $.spinner().stop();
                console.error('Error on Add To Cart:', err);
            });
        });

        // Open minicart on hover
        $('.minicart').on('mouseenter focusin', () => {
            const { showMiniCart, isDesktop } = getMinicartDisplayConfigs();
            if ($('.search:visible').length === 0 || !isDesktop) {
                return;
            }
            const url = $('.minicart').data('action-url');
            const count = parseInt($('.minicart .minicart-quantity').text(), 10);
            const forseMinicartUpdate = showMiniCart && isDesktop || false;

            if (count !== 0 && $('.minicart .popover.show').length === 0 && forseMinicartUpdate) {
                if (!updateMiniCart && !forseMinicartUpdate || !(window.SorUpdateMiniCart ? window.SorUpdateMiniCart : true)) {
                    $('.suggestions-wrapper').removeClass('open');
                    $('.background').addClass('active');
                    $('.minicart .popover').addClass('show');
                    return;
                }

                $('.suggestions-wrapper').removeClass('open');
                $('.background').addClass('active');
                $('.minicart .popover').addClass('show');
                $('.minicart .popover').spinner().start();
                $.get(url, (data) => {
                    $('.minicart .popover').empty();
                    $('.minicart .popover').append(data);
                    updateMiniCart = false;
                    window.SorUpdateMiniCart = false;
                    setMinicartBodyScrollToEnd();
                    $.spinner().stop();
                });
            }
        });
        $('body').on('click', (e) => {
            if ($('.minicart').has(e.target).length <= 0) {
                $('.background').removeClass('show');
                $('.minicart .popover').removeClass('show');
            }
        });

        // Stop showing minicart on hover
        $('.minicart').on('mouseleave focusout', (event) => {
            const { isDesktop } = getMinicartDisplayConfigs();
            // relatedTarget when moving forward and target when moving backwards via tab key
            const containedTarget = event.relatedTarget || event.target;

            if ((event.type === 'focusout' && $('.minicart').has(containedTarget).length > 0)
                || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
                || $('body').hasClass('modal-open') || !isDesktop) {
                event.stopPropagation();
                return;
            }

            if (parseInt($('.minicart-quantity').text(), 10) > 0 && !$('.navbar__toggler').hasClass('open')) {
              $('.background').removeClass('active')
            }
            $('.minicart .popover').removeClass('show');
        });

        $('body').on('change', '.minicart .quantity', function () {
            if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
                window.location.reload();
            }
        });

        $('body').on('product:afterAddToCart', () => {
            updateMiniCart = true;
        });

        $('body').on('cart:update', () => {
            updateMiniCart = true;
        });

        $('body').on('click', '.minicart-link', function () {
            const { isDesktop } = getMinicartDisplayConfigs();
            if (!isDesktop) {
                // When opening the cart start a spinner - only on mobile
                $.spinner().start();
            }
        });
    }
}
